/**
 * CustomerOrderItemCache entity - cached COI per customer for offline use.
 */

import type { EntitySchema } from '../types';

export interface CustomerOrderItemCache extends Record<string, unknown> {
  id: string;
  company_id: string;
  customer_key: string;
  commercial_code: string;
  location_code: string;
  item_id: string;
  item_code: string;
  selling_type: string;
  default_price: number;
  default_unit_price: number;
  selling_price: number;
  selling_unit_price: number;
  packing_quantity: number;
  quantity: number;
  sale_percent_value: number;
  sale_selling_packing_value: number;
  sale_selling_unit_value: number;
  vat_percent_value: number;
  available_stock: number;
  data: Record<string, unknown>;
  updated_at: string;
}

export const CustomerOrderItemCacheSchema: EntitySchema<CustomerOrderItemCache> =
  {
    tableName: 'customer_order_items_cache',
    columns: [
      { name: 'id', type: 'TEXT', primary: true },
      { name: 'company_id', type: 'TEXT', nullable: false },
      { name: 'customer_key', type: 'TEXT', nullable: false },
      { name: 'commercial_code', type: 'TEXT', nullable: false },
      { name: 'location_code', type: 'TEXT', nullable: false, default: '' },
      { name: 'item_id', type: 'TEXT', nullable: false },
      { name: 'item_code', type: 'TEXT', nullable: false },
      { name: 'selling_type', type: 'TEXT', nullable: false, default: 'selling' },
      { name: 'default_price', type: 'REAL', nullable: false, default: 0 },
      { name: 'default_unit_price', type: 'REAL', nullable: false, default: 0 },
      { name: 'selling_price', type: 'REAL', nullable: false, default: 0 },
      { name: 'selling_unit_price', type: 'REAL', nullable: false, default: 0 },
      { name: 'packing_quantity', type: 'REAL', nullable: false, default: 1 },
      { name: 'quantity', type: 'REAL', nullable: false, default: 1 },
      { name: 'sale_percent_value', type: 'REAL', nullable: false, default: 0 },
      {
        name: 'sale_selling_packing_value',
        type: 'REAL',
        nullable: false,
        default: 0,
      },
      {
        name: 'sale_selling_unit_value',
        type: 'REAL',
        nullable: false,
        default: 0,
      },
      { name: 'vat_percent_value', type: 'REAL', nullable: false, default: 0 },
      { name: 'available_stock', type: 'INTEGER', nullable: false, default: 1 },
      { name: 'data', type: 'COMPRESSED_JSON', nullable: false },
      { name: 'updated_at', type: 'TEXT', nullable: false },
    ],
    indexes: [
      { name: 'idx_coi_customer_key', columns: ['customer_key'] },
      { name: 'idx_coi_company', columns: ['company_id'] },
      { name: 'idx_coi_item', columns: ['item_code'] },
      { name: 'idx_coi_selling_type', columns: ['customer_key', 'selling_type'] },
      {
        name: 'idx_coi_unique',
        columns: ['customer_key', 'item_id', 'selling_type'],
        unique: true,
      },
    ],
  };
